<template>
  <Modal :id="'cmp-add-task'" @cancelled="onCancelClick">
    <template slot="header">{{ $t("add_new_memo") }}</template>
    <template slot="body">
      <div class="ut-flex ut-m-4px">
        <div class="contact-search">
          <InputField
            :value="searchString"
            :placeholder="$t('search')"
            :config="{
              borderStyle: 'around',
              minWidth: `200px`,
            }"
            @keyup="onSearchInputKeyup"
          ></InputField>
        </div>
        <button
          class="dt-button v1 s6 ut-ml-8px"
          v-if="isShowAddItemButton"
          @click="(e) => onAddItemButtonClick(e)"
        >
          {{$t('add_item')}}
        </button>
      </div>
      <div class="tsk-list-section-list ut-flex-mob-col">
        <div class="tsk-list-section ut-fc">
          <div class="tsk-list-section-title"> {{$t('all_items')}} </div>
          <div class="tsk-list-section-body">
            <div class="tsk-list-section--list" v-if="checklist_items">
              <div
                class="tsk-list-section--item"
                v-for="item of checklist_items"
                :key="item.checklist_id"
              >
                <div class="tsk-lsi--checkbox">
                  <div class="dt-checkbox v2 s1">
                    <input
                      type="checkbox"
                      :name="item.checklist_id"
                      :id="item.checklist_id"
                      :checked="selectedTasks.has(item.checklist_id)"
                      @click="(e) => onCheckboxChange(e, item)"
                    />
                    <div class="checkmark"></div>
                  </div>
                </div>
                <div class="tsk-lsi--body">
                  <div
                    class="tsk-lsi--main"
                    @click="onClick(item)"
                    v-if="!item.editing"
                  >
                    <div class="tsk-lsi--title">
                      {{ getHeader(item.name) }}
                    </div>
                    <small v-if="getBody(item.name)" class="tsk-lsi--subtitle">
                      {{ getBody(item.name) }}
                    </small>
                  </div>
                  <TextField2
                    v-if="item.editing"
                    type="text"
                    class="dbox1"
                    :id="'ci_' + item.checklist_id"
                    :showLabel="false"
                    :disabled="false"
                    placeholder=""
                    :value="item.name"
                    :name="item.name"
                    :bb="'0px'"
                    @change="(e) => onChecklistItemNameBlur(e, item)"
                  />
                </div>
                <div class="dt-icon-container">
                  <img
                    src="static/icons/edit.svg"
                    class="dt-icon v5 s1"
                    @click="(e) => onChecklistItemEdit(item)"
                    alt
                  />
                </div>
                <div class="dt-icon-container">
                  <img
                    src="static/icons/delete.svg"
                    @click="(e) => onTaskDelete(item)"
                    class="dt-icon v5 s1"
                    alt
                  />
                </div>
                <v-layout v-if="false" row wrap>
                  <v-flex md1>
                    <div class="dt-checkbox v2 s1">
                      <input
                        type="checkbox"
                        :name="item.checklist_id"
                        :id="item.checklist_id"
                        :checked="selectedTasks.has(item.checklist_id)"
                        @click="(e) => onCheckboxChange(e, item)"
                      />
                      <div class="checkmark"></div>
                    </div>
                  </v-flex>
                  <v-flex md11>
                    <template v-if="!item.editing">
                      <div class="ut-fh ut-colcen" @click="onClick(item)">
                        <span>
                          {{ getHeader(item.name) }}
                        </span>
                        <small>
                          {{ getBody(item.name) }}
                        </small>
                      </div>
                    </template>
                    <template v-else>
                      <TextField2
                        type="text"
                        class="dbox1"
                        :id="'ci_' + item.checklist_id"
                        :showLabel="false"
                        :disabled="false"
                        placeholder=""
                        :value="item.name"
                        :name="item.name"
                        :bb="'0px'"
                        @change="(e) => onChecklistItemNameBlur(e, item)"
                      />
                      <!-- <input
                          type="text"
                          :value="item.name"
                          :name="item.name"
                          :id="'ci_'+item.checklist_id"
                          class="dt-textbox"
                          @blur="e => onChecklistItemNameBlur(e, item)"
                        /> -->
                    </template>
                  </v-flex>
                </v-layout>
                <div v-if="false" class="dt-list-item--icon">
                  <div class="dt-icon-container">
                    <img
                      src="static/icons/edit.svg"
                      class="dt-icon v5"
                      @click="(e) => onChecklistItemEdit(item)"
                      alt
                    />
                  </div>
                </div>
                <div v-if="false" class="dt-list-item--icon">
                  <div class="dt-icon-container">
                    <img
                      src="static/icons/delete.svg"
                      @click="(e) => onTaskDelete(item)"
                      class="dt-icon v5"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tsk-list-section ut-fc">
          <div class="tsk-list-section-title"> {{$t('selected_items')}} </div>
          <div class="tsk-list-section-body">
            <div class="tsk-list-section--list" v-if="checklist_groups_items">
              <div
                class="tsk-list-section--item"
                v-for="item of checklist_groups_items"
                :key="item.name"
              >
                <div class="tsk-lsi--checkbox">
                  <div class="dt-checkbox v2 s1">
                    <input
                      type="checkbox"
                      :name="item.name"
                      :id="item.name"
                      :checked="selectedChecklistGroup.has(item.name)"
                      @click="(e) => onGroupCheckboxChange(e, item)"
                    />
                    <div class="checkmark"></div>
                  </div>
                </div>
                <div class="tsk-lsi--body">
                  <div
                    class="tsk-lsi--main"
                    @click="onClick(item)"
                    v-if="!item.editing"
                  >
                    <div class="tsk-lsi--title">
                      {{ getHeader(item.name) }}
                    </div>
                    <small
                      :style="{
                        maxHeight: selectedChecklistGroup.has(item.name)
                          ? '200px'
                          : '0px',
                        marginBottom: selectedChecklistGroup.has(item.name)
                          ? '8px'
                          : '0px',
                      }"
                      class="tsk-lsi--subtitle"
                    >
                      <span
                        v-for="item of item.checklist_items"
                        :key="item.name"
                      >
                        • {{ item.name }}
                        <br />
                      </span>
                    </small>
                  </div>
                  <TextField2
                    v-if="item.editing"
                    type="text"
                    class="dbox1"
                    :id="'cg_' + item.id"
                    :showLabel="false"
                    :disabled="false"
                    placeholder=""
                    :value="item.name"
                    :name="item.name"
                    :bb="'0px'"
                    @change="(e) => onChecklistItemNameBlur(e, item)"
                  />
                </div>
                <div class="dt-icon-container">
                  <img
                    src="static/icons/edit.svg"
                    class="dt-icon v5 s1"
                    @click="(e) => onChecklistGroupNameEdit(item)"
                    alt
                  />
                </div>
                <div class="dt-icon-container">
                  <img
                    src="static/icons/delete.svg"
                    @click="(e) => onItemGroupDelete(item)"
                    class="dt-icon v5 s1"
                    alt
                  />
                </div>
                <div v-if="false" class="dt-list-item--body">
                  <div class="dt-list-item--text">
                    <v-layout row wrap>
                      <v-flex md1> </v-flex>
                      <v-flex md11>
                        <template v-if="!item.editing">
                          <div @click="onClick(item)">
                            <p style="margin-bottom: 5px; font-size: 16px">
                              {{ getHeader(item.name) }}
                            </p>
                            <p>
                              {{ getBody(item.name) }}
                            </p>
                          </div>
                        </template>
                        <template v-else>
                          <TextField2
                            type="text"
                            class="dbox1"
                            :id="'cg_' + item.id"
                            :showLabel="false"
                            :disabled="false"
                            placeholder=""
                            :value="item.name"
                            :name="item.name"
                            :bb="'0px'"
                            @change="(e) => onChecklistItemNameBlur(e, item)"
                          />
                        </template>
                        <div
                          class="children-checklists"
                          :class="{
                            expanded: selectedChecklistGroup.has(item.name),
                          }"
                        >
                          <span
                            v-for="item of item.checklist_items"
                            :key="item.name"
                          >
                            {{ item.name }}
                            <br />
                          </span>
                        </div>
                      </v-flex>
                    </v-layout>
                  </div>
                  <div class="dt-list-item--icon">
                    <div class="dt-icon-container">
                      <img
                        src="static/icons/edit.svg"
                        class="dt-icon v5"
                        @click="(e) => onChecklistGroupNameEdit(item)"
                        alt
                      />
                    </div>
                  </div>
                  <div class="dt-list-item--icon">
                    <div class="dt-icon-container">
                      <img
                        src="static/icons/delete.svg"
                        @click="(e) => onItemGroupDelete(item)"
                        class="dt-icon v5"
                        alt
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isAIEnabled" class="tsk-list-section ut-fc">
          <div class="tsk-list-section-title"> {{$t('ai_items')}} </div>
          <div class="tsk-list-section-body">
            <div class="tsk-list-section--list" v-if="aiTasks">
              <div
                class="tsk-list-section--item"
                v-for="(item, index) of aiTasks"
                :key="`aii${index}`"
              >
                <div class="tsk-lsi--checkbox">
                  <div class="dt-checkbox v2 s1">
                    <input
                      type="checkbox"
                      :name="item.name"
                      :id="item.name"
                      :checked="item.assignedTask"
                      @click="(e) => onAITaskCheckboxChange(e, item)"
                    />
                    <div class="checkmark"></div>
                  </div>
                </div>
                <div class="tsk-lsi--body">
                  <div class="tsk-lsi--main">
                    <div class="tsk-lsi--title">
                      {{ item.type }}
                    </div>
                    <small v-if="item.task" class="tsk-lsi--subtitle">
                      {{ item.task }}
                    </small>
                  </div>
                </div>
                <div class="dt-icon-container">
                  <img
                    src="static/icons/edit.svg"
                    class="dt-icon v5 s1"
                    @click="(e) => onChecklistAIEdit(e, item)"
                    alt
                  />
                </div>
                <v-menu
                  v-model="aiEditMenu.show"
                  :position-x="aiEditMenu.x"
                  :position-y="aiEditMenu.y"
                  absolute
                  offset-y
                  :close-on-content-click="false"
                >
                  <div
                    v-if="aiEditMenu.item"
                    style="width: 280px; background: white; padding: 16px"
                  >
                    <span class="dt-title--title">{{
                      aiEditMenu.item && aiEditMenu.item.type
                    }}</span
                    ><br />
                    <div class="ut-fh ut-fc">
                      <NTable
                        v-if="
                          aiEditMenu.taskReminderPoints &&
                          aiEditMenu.taskReminderPoints.length > 0
                        "
                        class="task_reminder_points dbox1"
                        :headers="taskReminderPointsHeaders"
                        :id="'booking-booking-booking_sidewindow-task_reminder_points'"
                        :items="aiEditMenu.taskReminderPoints"
                        :config="tableConfig"
                        :height="`${aiEditMenu.taskReminderPoints * 32}px`"
                      >
                        <template v-slot:item="{ item, index, tdcon }">
                          <tr>
                            <td v-bind="tdcon('checkbox')">
                              <div
                                class="dt-checkbox v2 s1"
                                style="margin: auto 10px"
                              >
                                <input
                                  type="checkbox"
                                  :name="
                                    'cb_ai_rp__' +
                                    aiEditMenu.item.taskTypeSlug +
                                    '__' +
                                    index +
                                    '__' +
                                    item
                                  "
                                  :id="
                                    'cb_ai_rp__' +
                                    aiEditMenu.item.taskTypeSlug +
                                    '__' +
                                    index +
                                    '__' +
                                    item
                                  "
                                  :class="
                                    'cb_ai_rp__' + aiEditMenu.item.taskTypeSlug
                                  "
                                  :value="item"
                                  :checked="
                                    aiEditMenu.taskReminderPoints[index] > 0 ||
                                    (item == 'now' &&
                                      aiEditMenu.item.task.indexOf('now') >= 0)
                                  "
                                  @click="
                                    (e) =>
                                      onAITaskPointCheckboxChange(
                                        e,
                                        item,
                                        index
                                      )
                                  "
                                />
                                <div class="checkmark"></div>
                              </div>
                            </td>
                            <td v-bind="tdcon('days_count')">
                              <div v-if="item == 'now'"> {{$t('now')}} </div>
                              <div v-else>
                                <TextField2
                                  type="text"
                                  class="dbox1"
                                  :id="
                                    'ai_rp__' +
                                    aiEditMenu.item.taskTypeSlug +
                                    '__' +
                                    index +
                                    '__' +
                                    item
                                  "
                                  :showLabel="false"
                                  :placeholder="$t('days')"
                                  :value="item"
                                  :bb="'0px'"
                                  @change="
                                    (e) =>
                                      onAIReminderPointTextChange(
                                        e,
                                        item,
                                        index
                                      )
                                  "
                                />
                              </div>
                            </td>
                            <td v-bind="tdcon('text')">
                              <span v-if="item != 'now'"
                                > {{$t('days_before_event')}} </span
                              >
                            </td>
                          </tr>
                        </template>
                      </NTable>
                    </div>
                    <div class="ut-flex ut-mt-16px">
                      <button
                        class="dt-button s6 ut-mr-4px"
                        @click="
                          (e) => onAIReminderPointEditClose(e, aiEditMenu.item)
                        "
                      >
                        {{ $t("cancel") }}
                      </button>
                      <button
                        class="dt-button v1 s6 ut-ml-4px"
                        @click="
                          (e) => onAIReminderPointEditDone(e, aiEditMenu.item)
                        "
                      >
                        {{ $t("save_btn") }}
                      </button>
                    </div>
                    <div v-if="false">
                      <div
                        class="dt-list-item"
                        v-for="(item, index) of aiEditMenu.taskReminderPoints"
                        :key="`aii${index}`"
                      >
                        <div class="dt-list-item--body">
                          <div class="dt-list-item--text">
                            <v-layout row wrap align-center justify-center>
                              <v-flex md1>
                                <div class="dt-checkbox v2 s1">
                                  <input
                                    type="checkbox"
                                    :name="
                                      'cb_ai_rp__' +
                                      aiEditMenu.item.taskTypeSlug +
                                      '__' +
                                      index +
                                      '__' +
                                      item
                                    "
                                    :id="
                                      'cb_ai_rp__' +
                                      aiEditMenu.item.taskTypeSlug +
                                      '__' +
                                      index +
                                      '__' +
                                      item
                                    "
                                    :class="
                                      'cb_ai_rp__' +
                                      aiEditMenu.item.taskTypeSlug
                                    "
                                    :value="item"
                                    :checked="
                                      aiEditMenu.taskReminderPoints[index] >
                                        0 ||
                                      (item == 'now' &&
                                        aiEditMenu.item.task.indexOf('now') >=
                                          0)
                                    "
                                    @click="
                                      (e) =>
                                        onAITaskPointCheckboxChange(
                                          e,
                                          item,
                                          index
                                        )
                                    "
                                  />
                                  <div class="checkmark"></div>
                                </div>
                              </v-flex>
                              <v-flex md11 class="pl-2">
                                <template v-if="item == 'now'">
                                  {{ item }}
                                </template>
                                <v-layout
                                  align-center
                                  justify-center
                                  row
                                  v-else
                                >
                                  <v-flex md3>
                                    <TextField
                                      :id="
                                        'ai_rp__' +
                                        aiEditMenu.item.taskTypeSlug +
                                        '__' +
                                        index +
                                        '__' +
                                        item
                                      "
                                      v-bind="textFieldConfigAI"
                                      :value="item"
                                      @valuechanged="
                                        (name, value) =>
                                          onAIReminderPointTextBoxBlur(
                                            name,
                                            value,
                                            item,
                                            index
                                          )
                                      "
                                    ></TextField>
                                  </v-flex>
                                  <v-flex md9> {{$t('days_before_event')}} </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-menu>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="task-assignment ut-flex-mob-col-stretch ut-mt-8px">
        <div class="ut-flex-1" style="">
          <TextField
            :id="'groupName'"
            v-bind="textFieldConfig"
            v-model="groupName"
            isModel
            :placeholder="$t('group_name')"
            :disabled="selectedTasks.size < 2"
          ></TextField>
        </div>
        <div class="ut-flex-1 ut-ml-8px">
          <div id="assignedMenuActivator" @mouseenter="onMenuActivatorEnter">
            <Dropdown
              class="dt-dropdown m2"
              :placeholder="$t('assign_to')"
              :options="usersItems"
              :selected="selectedUser"
              box
              v-on:selectedChange="onAssignedToChange"
            ></Dropdown>
          </div>
        </div>
        <div class="ut-flex-1 ut-ml-8px">
          <button
            class="dt-button v1 s6"
            @click="onDoneClick"
            :class="{
              disabled: doneButtonDisabled,
            }"
            :disabled="doneButtonDisabled"
          >

            {{$t('done')}}
          </button>
        </div>
      </div>

      <div style="position: absolute">
        <v-menu
          v-model="assingedChecklistMenu"
          :close-on-content-click="false"
          :position-x="assingedChecklistMenuConfig.left"
          :position-y="assingedChecklistMenuConfig.top"
          absolute
          offset-y
          :z-index="205"
        >
          <v-card
            class="checklist-menu"
            @mouseenter="onAssignedChecklistEnter"
            @mouseleave="onAssignedChecklistLeave"
          >
            <v-flex row wrap pa-2>
              <span class="dt-title--title"> {{$t('currently_assigned')}} </span>
              <div
                v-if="userChecklistItems && userChecklistItems.length > 0"
                class="dt-list assigned-menu"
              >
                <div
                  class="dt-list-item"
                  v-for="cItem of userChecklistItems"
                  :key="cItem.checklist_id"
                >
                  <div class="dt-list-item--body">{{ cItem.name }}</div>
                </div>
              </div>
              <div
                class="remove-button"
                v-if="userChecklistItems && userChecklistItems.length > 0"
              >
                <button class="dt-button s2" @click="onRemoveAllClick">
                  {{$t('remove_all')}}
                </button>
              </div>
              <div v-else> {{$t('no_task_assigned_yet')}} </div>
            </v-flex>
          </v-card>
        </v-menu>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick"> {{$t('close')}} </button>
    </template>
  </Modal>
</template>

<script>
import * as R from "ramda";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import transduce from "ramda/es/transduce";
import { mapGetters } from "vuex";
import {
  BookingStoreNamespace as storeNS,
  BookingStoreNamespace,
} from "../../store";
import * as ActionTypes from "../../store/types";
import { BookingService } from "../../services/booking-service";
import { addRemoveSet, offset } from "../../../../utility";
import InputField from "../../../../plugins/text-field/input-field";
import {
  createTaskModel,
  createChecklistGroupItems,
  createChecklistItems,
} from "../../models/task.model";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service.js";

import Modal from "../../../../dt-plugins/modal/modal";
import { join, match } from "ramda";
import { MHTTPCL } from "../../../../services/http/http-client";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";

export default {
  components: {
    InputField,
    Modal,
  },
  props: ["booking", "calendar_date_id"],
  data: function () {
    return {
      searchString: "",
      searchSubject$: new Subject(),
      checklist_groups_items: [],
      checklist_items: [],
      selectedTasks: new Set(),
      selectedChecklistGroup: new Set(),
      groupName: "",
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
      },
      selectedUser: null,
      userChecklistItems: [],
      assingedChecklistMenu: false,
      assingedChecklistMenuConfig: {
        x: 0,
        y: 0,
      },
      assignedMenuSubject$: new Subject(),
      overAssignedChecklist: false,

      task_users: [],

      aiTasks: [],
      aiEditMenu: { show: false, x: 0, y: 0, taskReminderPoints: [] },
      selectedAITaskPoints: new Set(),
      textFieldConfigAI: {
        height: 28,
        showEditIconOnHover: false,
        box: true,
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        footer: false,
      }),
    };
  },
  mounted: function () {
    this.loadChecklistFormData();

    this.$subscribeTo(
      this.searchSubject$
        .asObservable()
        .pipe(debounceTime(500), distinctUntilChanged()),
      (searchString) => {
        // console.log(searchString);
        BookingService.findChecklistItemByName({
          name: searchString,
        }).then((res) => {
          this.checklist_items = res.data.items.map(createTaskModel);
        });
      }
    );

    this.$subscribeTo(
      this.assignedMenuSubject$.asObservable().pipe(debounceTime(3000)),
      (value) => {
        if (!this.overAssignedChecklist) {
          this.assingedChecklistMenu = value;
        }
      }
    );
  },
  computed: {
    ...mapGetters({
      account: "account",
    }),
    isAIEnabled() {
      return this.account?.client_settings?.logistics_service_level == "1";
    },
    isShowAddItemButton() {
      const matchedItem = this.checklist_items.find(
        (row) => row.name == this.searchString
      );
      console.log("RRRRRRR", !matchedItem ? true : false);
      return this.searchString.length > 0 && !matchedItem ? true : false;
    },
    usersItems: function () {
      return (
        this.task_users
          ?.map((e) => ({
            text: e.user_name,
            value: e.user_id,
          }))
          .filter((e) => e.text && e.value) || []
      );
    },
    doneButtonDisabled: function () {
      if (this.selectedUser && this.selectedUser.value) {
        if (this.selectedTasks.size > 0) {
          if (this.selectedTasks.size > 1) {
            if (this.groupName && this.groupName.length > 0) {
              return false;
            } else {
              return true;
            }
          } else {
            return false;
          }
        } else if (this.selectedChecklistGroup.size > 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    calendarDateId: function () {
      return this.calendar_date_id;
    },
    taskReminderPointsHeaders: function () {
      return [
        createTableHeader("checkbox", {
          text: false,
          mw: 40,
          ta: "left",
        }),
        createTableHeader("days_count", { text: "Days", mw: 70 }),
        createTableHeader("text", { text: false }),
      ];
    },
  },
  methods: {
    getHeader: function (str) {
      return str.split(":")[0];
    },

    getBody: function (str) {
      const arr = str.split(":");

      // return arr.reduce((accum,cur)=>{
      //   return accum+=cur
      // },'')

      if (arr.length > 1) {
        return arr.reduce((accum, cur) => {
          return (accum += cur);
        }, "");
      } else {
        return "";
      }

      // console.log(str.split(":"));

      // return str.split(":")[1]
    },

    onClick: function (item) {
      console.log(this.checklist_items, "BEFORE :::::::::::", item);
      this.checklist_items = this.checklist_items.map((e) => {
        return {
          ...e,
          editing: false,
        };
      });

      this.checklist_groups_items = this.checklist_groups_items.map((e) => {
        return {
          ...e,
          editing: false,
        };
      });

      console.log(this.checklist_items, "AFTER :::::::::::");
    },

    loadChecklistFormData() {
      BookingService.findTaskChecklistForm({
        calendarDateId: this.calendarDateId,
      }).then((res) => {
        // console.log(res);
        this.checklist_groups_items = createChecklistGroupItems(
          res.data.checklist_groups_items
        );
        this.checklist_items = createChecklistItems(res);
        // console.log(this.checklist_groups_items, this.checklist_items);
        this.task_users = [
          ...(res.data.task_users.filter(
            (e) => e.user_name != "details_helper"
          ) || []),
          // res.data.task_users.find(e => e.user_name == 'details_helper'),
        ];

        // console.log(this.task_users);
        this.prepareAITasks(res.data);
      });
    },
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },
    onSearchInputKeyup: function (event) {
      this.searchString = event.target.value;
      // console.log(this.searchString);
      this.searchSubject$.next(this.searchString);
    },
    onTaskDelete: function (task) {
      this.checklist_items = this.checklist_items.filter(
        (e) => e.name != task.name
      );
      BookingService.removeChecklistItem({
        name: task.name,
      });
    },
    onCheckboxChange: function (event, task) {
      this.selectedChecklistGroup = new Set();
      this.selectedTasks = addRemoveSet(
        event.target.checked,
        this.selectedTasks,
        task.checklist_id
      );
    },
    onGroupCheckboxChange: function (event, item) {
      this.selectedTasks = new Set();
      this.selectedChecklistGroup = addRemoveSet(
        event.target.checked,
        this.selectedChecklistGroup,
        item.name
      );
    },
    onChecklistItemEdit: function (item) {
      this.checklist_groups_items = this.checklist_groups_items.map((e) => {
        return {
          ...e,
          editing: false,
        };
      });

      this.checklist_items = this.checklist_items.map((e) => {
        if (e.checklist_id == item.checklist_id) {
          return {
            ...e,
            editing: true,
          };
        } else {
          return {
            ...e,
            editing: false,
          };
        }
      });

      // item.editing = true;
      this.$set(item, "editing", true);

      setTimeout(() => {
        const inputEl = document.querySelector(`#ci_${item.checklist_id}`);
        inputEl && inputEl.focus();
      });
    },
    onChecklistItemNameBlur: async function (event, item) {
      // item.editing = false;

      console.log("::::::::::::::::", event, "::::::::::::::::");
      this.$set(item, "name", event.value);
      this.$set(item, "editing", false);

      await MHTTPCL.modifyJSON(
        "",
        item.checklist_id,
        "name",
        event.value,
        "checklist"
      );

      // BookingService.modifyChecklistItemName({
      //   checklistId: item.checklist_id,
      //   name: item.name
      // });
    },
    onChecklistGroupNameEdit: function (item) {
      console.log(item);

      this.checklist_items = this.checklist_items.map((e) => {
        return {
          ...e,
          editing: false,
        };
      });

      this.checklist_groups_items = this.checklist_groups_items.map((e) => {
        if (item.id == e.id) {
          return {
            ...e,
            editing: true,
          };
        } else {
          return {
            ...e,
            editing: false,
          };
        }
      });

      this.$set(item, "editing", true);

      setTimeout(() => {
        const inputEl = document.querySelector(`#cg_${item.id}`);
        inputEl && inputEl.focus();
      });
    },
    onChecklistGroupNameBlur: function (event, item) {
      const oldName = item.name;
      const newName = event.target.value;

      this.$set(item, "name", newName);
      this.$set(item, "editing", false);

      BookingService.modifyChecklistGroupName({
        oldName,
        newName,
      });
    },
    onAssignedToChange: function (event) {
      // console.log(event);
      this.selectedUser = event;
      // console.log(this.selectedUser);
      BookingService.findChecklistItemByAssignedUser({
        userId: event.value,
        calendarDateId: this.calendarDateId,
      }).then((res) => {
        this.processAssignedData(res);
      });
    },
    onGroupNameChange: function (event) {
      // console.log(event);
    },
    activateAssignedMenu: function () {
      // if (!(this.userChecklistItems && this.userChecklistItems.length > 0)) {
      //   return;
      // }
      this.assingedChecklistMenu = true;

      const assignedMenuActivator = document.querySelector(
        "#assignedMenuActivator"
      );
      const { top, left } = offset(assignedMenuActivator);

      this.assingedChecklistMenuConfig = {
        top: top + 41,
        left,
      };

      this.assignedMenuSubject$.next(false);
    },
    onMenuActivatorEnter: function (event) {
      if (this.selectedUser) {
        this.activateAssignedMenu();
      }
    },
    onAssignedChecklistEnter: function (event) {
      this.overAssignedChecklist = true;
    },
    onAssignedChecklistLeave: function (event) {
      if (this.overAssignedChecklist) {
        this.assingedChecklistMenu = false;
        this.overAssignedChecklist = false;
      }
    },
    onRemoveAllClick: function (event) {
      // console.log('onRemoveAllClick');
      BookingService.removeUserAssingedTasks({
        calendarDateId: this.calendarDateId,
        userId: this.selectedUser.value,
      }).then((res) => {
        this.processAssignedData(res);
      });
    },
    processAssignedData: function (res) {
      if (res.data.items && res.data.items.length > 0) {
        this.userChecklistItems = res.data.items.map(createTaskModel);
      } else {
        this.userChecklistItems = [];
      }
      this.activateAssignedMenu();
    },
    onItemGroupDelete: function (item) {
      this.checklist_groups_items = this.checklist_groups_items.filter(
        (e) => e.name != item.name
      );
      BookingService.removeChecklistItemGroup({
        groupName: item.name,
      });
    },
    onDoneClick: function (event) {
      // console.log(this.selectedChecklistGroup);

      if (this.selectedChecklistGroup.size > 0) {
        this.assignChecklistGroup();
      } else if (this.selectedTasks.size > 0) {
        this.assignChecklistItems();
      }
    },
    assignChecklistItems: function () {
      const groupName =
        this.selectedTasks.size == 1
          ? this.checklist_items.find(
              (e) => e.checklist_id == Array.from(this.selectedTasks)[0]
            ).name
          : this.groupName;

      // console.log(groupName);

      BookingService.assignToUser({
        from: "items",
        userId: this.selectedUser.value,
        calendarDateId: this.calendarDateId,
        items: `[${Array.from(this.selectedTasks).map((e) => `"${e}"`)}]`,
        groupName,
      }).then((res) => {
        console.log(res);
        if (res.data.success == 1) {
          this.$emit("done", true);
        } else {
          NotificationService.showNotification({
            text: "Group name already taken!",
            timeout: 6000,
            color: "error",
          });
        }
      });
    },
    assignChecklistGroup: function () {
      // console.log({ from: 'groups', userId: this.selectedUser.value, calendarDateId: this.calendarDateId, selectedGroups: `[${Array.from(this.selectedChecklistGroup).map(e => `"${e}"`)}]`, }, this.selectedChecklistGroup);

      BookingService.assignToUser({
        from: "groups",
        userId: this.selectedUser.value,
        calendarDateId: this.calendarDateId,
        selectedGroups: `[${Array.from(this.selectedChecklistGroup).map(
          (e) => `"${e}"`
        )}]`,
      }).then((res) => {
        if (res.data.success == 1) {
          this.$emit("done", true);
        } else {
          NotificationService.showNotification({
            text: "Group name already taken!",
            timeout: 6000,
            color: "error",
          });
        }
      });
    },
    prepareAITasks(resData) {
      const defaultTasks = resData?.default_ai_tasks || [];
      const assignedTasks = resData?.assigned_task_items || [];

      const aiTasks = defaultTasks.map((row) => {
        const itemSplits = row.split(":");
        const taskType = itemSplits[0].trim();
        const taskTypeSlug = taskType.split(" ").join("_").toLowerCase();
        const defaultTask = itemSplits[1];
        const assignedTask = assignedTasks.find(
          (row) => row.name.toLowerCase().indexOf(taskType.toLowerCase()) >= 0
        );
        const selectedTask = assignedTask ? assignedTask.name : row;
        let taskReminderPoints = selectedTask.match(/\d+/g)?.map(Number) || [];
        if (defaultTask.indexOf("now") >= 0) {
          taskReminderPoints.unshift("now");
        }

        const initLenght = taskReminderPoints.length;
        const maxPointOption = 5;
        if (initLenght < maxPointOption) {
          for (let i = 1; i <= maxPointOption - initLenght; i++) {
            taskReminderPoints.push("");
          }
        }

        return {
          type: taskType,
          taskTypeSlug,
          task: selectedTask.split(":")[1].trim(),
          points: taskReminderPoints,
          assignedTask,
          defaultTask,
        };
      });

      this.aiTasks = aiTasks;
      // console.log('aiTasks: ', aiTasks);
    },
    onAITaskCheckboxChange(event, item) {
      const isChecked = event.target.checked;
      if (isChecked === false && item.assignedTask) {
        //Delete task form calndardateID by checklist_id
        BookingService.uncheckCustomChecklistItem(
          item.assignedTask.checklist_id
        ).then((res) => {
          this.loadChecklistFormData();
          this.onAITaskAssignDone();
        });
      } else if (isChecked === true && !item.assignedTask) {
        //Assign AI task
        BookingService.assignAITask({
          task: item.type + ": " + item.task,
          calendarDateId: this.calendarDateId,
        }).then((res) => {
          this.loadChecklistFormData();
          this.onAITaskAssignDone();
        });
      }
    },
    onAITaskPointCheckboxChange(event, item) {
      // this.selectedTasks = new Set();
      // this.selectedChecklistGroup = addRemoveSet(
      //   event.target.checked,
      //   this.selectedChecklistGroup,
      //   item.name
      // );
    },
    onChecklistAIEdit: function (e, item) {
      e.preventDefault();
      this.selectedAITaskPoints = new Set(item.points);
      this.aiEditMenu.show = false;
      this.aiEditMenu.x = e.clientX;
      this.aiEditMenu.y = e.clientY;
      this.aiEditMenu.item = item;
      this.aiEditMenu.taskReminderPoints = item.points;
      this.$nextTick(() => {
        this.aiEditMenu.show = true;
      });
    },
    onAIReminderPointTextBoxBlur(name, value, item, index) {
      this.$set(this.aiEditMenu.taskReminderPoints, index, value);

      // Sync checkbox value with input field value
      document.getElementById("cb_" + name).value = value;

      // console.log(`${value} -- ${item} -- ${index}`, this.aiEditMenu.taskReminderPoints);
    },
    onAIReminderPointTextChange(e, item, index) {
      // console.log(`${value} -- ${item} -- ${index}`, this.aiEditMenu.taskReminderPoints);

      const name = e.name;
      const value = e.value;

      this.$set(this.aiEditMenu.taskReminderPoints, index, value);

      // Sync checkbox value with input field value
      document.getElementById("cb_" + name).value = value;
    },
    onAIReminderPointEditClose: function (e, aiItem) {
      this.aiEditMenu.show = false;
    },
    onAIReminderPointEditDone: function (e, aiItem) {
      // console.log(item);

      let cbs = document.querySelectorAll(
        ".cb_ai_rp__" + aiItem.taskTypeSlug + ":checked"
      );
      let selectedPoints = [],
        isNow = false,
        i;

      for (i = 0; i < cbs.length; i++) {
        let pointValue = cbs[i].value;
        if (pointValue == "now") {
          isNow = true;
        } else {
          let pointValueNum = Number(pointValue);
          if (pointValueNum > 0) {
            selectedPoints.push(pointValueNum);
          }
        }
      }

      //Sort desc order
      selectedPoints.sort((a, b) => b - a);

      let newAITasks = selectedPoints.map((row) => row + " days before event");

      //Remove Duplicate
      newAITasks = [...new Set(newAITasks)];

      if (isNow === true) {
        newAITasks.unshift("now");
      }

      // return false if no reminder point selected.
      if (newAITasks.length < 1) {
        return false;
      }

      let newAITask = newAITasks.join(" and ");
      newAITask =
        newAITasks.length > 0 ? aiItem.type + ": " + newAITask : aiItem.type;

      const newParams = {
        task: newAITask,
        checklist_id: aiItem.assignedTask?.checklist_id,
        calendarDateId: this.calendarDateId,
      };
      BookingService.assignAITask(newParams).then((res) => {
        // console.log(res.data);
        this.loadChecklistFormData();
        this.onAITaskAssignDone();
      });
      this.onAIReminderPointEditClose();

      // console.log('selected: ', newParams);
    },
    onAITaskAssignDone() {
      this.$emit("doneAI");
    },
    onAddItemButtonClick() {
      const name = this.searchString;
      BookingService.addNewChecklistItem({ name }).then((res) => {
        this.loadChecklistFormData();
        this.searchString = "";
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-add-task {
  .tsk-list-section-list {
    margin-top: 16px;
    align-items: stretch;

    .tsk-list-section {
      // max-width: 33.33%;
      // min-width: 33.33%;
      flex: 1 0 200px;
      margin: 0px  4px;

      &:not(:last-child) {
        padding-right: 8px;
        // min-height: 100%;
        // border-right: 1px solid var(--border-color);
      }

      // Target mobile
      @media (max-width: 767px) {
        margin-top: 16px;
        // max-width: 100%;
        // min-width: 100%;
        .tsk-list-section-title {
          // font-size: 1.2rem;
        }
      }
      .tsk-list-section-title {
        color: var(--text-secondary);
      }
      .tsk-list-section-body {
        .tsk-list-section--list {
          display: flex;
          flex-direction: column;
          .tsk-list-section--item {
            display: flex;
            // align-items: flex-start;

            min-height: 32px;
            border-bottom: 1px solid var(--border-color);

            .tsk-lsi--checkbox {
              max-width: 50px;
              margin-right: 8px;

              height: 31px;
              display: flex;
              flex-direction: column;
              justify-content: center;
            }
            .tsk-lsi--body {
              flex: 1;
              .tsk-lsi--main {
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .tsk-lsi--title {
                  min-height: 31px;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                }
                .tsk-lsi--subtitle {
                  margin-bottom: 8px;
                  transition: max-height 300ms ease-out, margin 50ms ease-out;
                  overflow: hidden;
                }
              }
            }
            .dt-icon-container {
              height: 31px;
            }
          }
        }
      }
    }
  }

  .task-assignment {
    @media (max-width: 767px) {
      .ut-flex-1:last-child {
        margin-top: 4px;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.tasks-container {
  // height: 360px;
  // overflow-y: auto;
  // overflow-x: hidden;
  // width: 100%;
}

.dt-list-item {
  height: auto;
  .dt-list-item--text {
    &:first-child {
      flex: 2;
    }
  }

  .dt-list-item--body {
    width: 100%;

    .dt-checkbox {
      margin-top: 5px;
    }

    .children-checklists {
      max-height: 0px;
      overflow: hidden;

      transition: 300ms ease-out;

      &.expanded {
        max-height: 200px;
      }
    }
  }
}

.checklist-menu {
  width: 200px;
}

.dt-list.assigned-menu {
  margin-top: 10px;
  max-height: 200px;
  overflow-y: auto;
}

.done-button {
  // margin: 5px !important;
}
</style>
